module.exports = __webpack_public_path__ + "img/IMG_3797.9b59850e.jpg";